"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon"));

require("../styles/_breadcrumbs.scss");

function pushLink(a, b) {
  return function (c) {
    c.preventDefault(), a.push(b);
  };
}

var renderBreadCrumbLink = function renderBreadCrumbLink(a, b, c) {
  return _react["default"].createElement("a", {
    className: (0, _classnames["default"])("breadcrumbs__breadcrumb__link", {
      "breadcrumbs__breadcrumb__link--dark-mode": c
    }),
    href: a.url,
    onClick: pushLink(b, a.url)
  }, a.title);
};

function BreadCrumbs(a) {
  var b = a.items,
      c = a.darkMode,
      d = a.separatorIconName,
      e = a.separatorIconSize,
      f = a.history;
  return b && f ? _react["default"].createElement("ul", {
    className: "breadcrumbs"
  }, b.map(function (a) {
    return a.url ? _react["default"].createElement("li", {
      key: a.url,
      className: "breadcrumbs__breadcrumb"
    }, renderBreadCrumbLink(a, f, !!c), _react["default"].createElement("span", {
      className: (0, _classnames["default"])("breadcrumbs__breadcrumb__icon", {
        "breadcrumbs__breadcrumb__icon--dark-mode": c
      })
    }, _react["default"].createElement(_Icon["default"], {
      name: d,
      color: c ? "white" : "black",
      size: e
    }))) : null;
  })) : null;
}

BreadCrumbs.displayName = "BreadCrumbs", BreadCrumbs.defaultProps = {
  darkMode: !1,
  separatorIconName: "chevronright",
  separatorIconSize: 15
};

var _default = (0, _react.memo)(BreadCrumbs);

exports["default"] = _default;